(/** @lends <global> */function (global) {
    'use strict';

    var HelpScene = require('helpscene').HelpScene;

    var DerivedHelpScene = function (controller, model, math, config) {
        HelpScene.call(this, controller, model, math, config);

        //
    };

    DerivedHelpScene.prototype = Object.create(HelpScene.prototype);

    DerivedHelpScene.prototype.constructor = DerivedHelpScene;

    DerivedHelpScene.prototype.terminate = function () {
        this.removeChildren();
        this.destroy();

        //
    };

    DerivedHelpScene.prototype.preparePricetable = function () {

        this.prices = {};
        this.prices2 = {};

        for (var i = 0, max = this.config.pricetable.length; i < max; ++i) {
            var symbol = this.config.pricetable[i].symbol;
            var wins = this.config.pricetable[i].wins;
            var startPosition = this.config.pricetable[i].position;
            var offset = this.config.pricetable[i].offset;
            var align = this.config.pricetable[i].align || 'center';

            var offsetSecondX = this.config.pricetable[i].offsetSecondX;

            this.prices[symbol] = {price:[]};
            this.prices2[symbol] = {price:[]};

            for (var j = 0; j < wins.length; ++j) {
                for (var k = 0; k < 2; ++k) {
                    var font = k === 0 ? this.config.priceFontName : this.config.priceFontNameSecond;
                    var label = new PIXI.extras.BitmapText("", {font: font, align: align});
                    this.pages[0].addChild(label);

                    var x;
                    var y;
                    //if object with x and y values:
                    if (!isNaN(startPosition.x)) {
                        x = startPosition.x;
                        y = startPosition.y;
                    }
                    //otherwise array of such objects is expected:
                    else {
                        x = startPosition[j].x;
                        y = startPosition[j].y;
                    }

                    label.x = x + ( offset ? offset.width : 0 ) * j;
                    label.y = y + ( offset ? offset.height : 0 ) * j;

                    switch (align) {
                        case 'left':
                            label.anchor.set(0.0, 0.0);
                            break;

                        case 'right':
                            label.anchor.set(1.0, 0.0);
                            break;

                        case 'center':
                            label.anchor.set(0.5, 0.0);
                            break;

                        default:
                            label.anchor.set(0.5, 0.0);
                            break;
                    }

                    if(k === 0) {

                        this.prices[symbol].price.push(label);
                    }
                    else
                    {
                        label.x += offsetSecondX;
                        this.prices2[symbol].price.push(label);
                    }
                }
            }
        }
    };

    DerivedHelpScene.prototype.updatePricetable = function (lines, multiplier) {
        for (var i = 0, max = this.config.pricetable.length; i < max; ++i) {
            var symbol = this.config.pricetable[i].symbol;
            var wins = this.config.pricetable[i].wins;

            var offsetSecondX = this.config.pricetable[i].offsetSecondX;

            for (var j = 0; j < wins.length; ++j) {
                var winValue = this.math.price(symbol, wins[j]);
                if (symbol === this.math.scatter) {
                    // RX
                    winValue *= lines * multiplier;
                }
                else {
                    // RX
                    winValue *= multiplier;
                }

                this.prices[symbol].price[j].text = winValue;

                if(offsetSecondX !== 0) {
                    this.prices2[symbol].price[j].text = winValue * 2;
                }
            }
        }
    };

    global.DerivedHelpScene = DerivedHelpScene;
}(typeof module === 'object' && module.exports || this));





//////////////////
// WEBPACK FOOTER
// ./src/derived-help.js
// module id = 88
// module chunks = 0